import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Slider from './Slider';
import apis from '../../../app/apis';


const Container = styled.div`
  padding: 10px;
  text-align: center;
`;

const Img = styled.img`
  max-width: 360px;
  border-radius: 10px;
  min-height: 360px;

  @media screen and (min-width: 768px) and (max-width: 914px) {
    max-width: 287px;
    min-height: 287px;
  }

  @media screen and (min-width: 410px) and (max-width: 469px) {
    max-width: 300px;
    min-height: 300px;
  }

  @media screen and (max-width: 409px) {
    max-width: 209px;
    min-height: 209px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: 380px) and (max-width: 555px) {
    height: 272px;
  }

  @media screen and (min-width: 320px) and (max-width: 380px) {
    height: 200px;
  }
`;

const Image = ({ images, localityId, alt }) => {
  const imageUrl = (path) => apis.imageUrl(localityId, path);

  const renderImage = () => {
    if (!images.length) return null;
    if (images.length > 1) {
      return (
        <Wrapper>
          <Slider images={images} imageUrl={imageUrl} />
        </Wrapper>
      );
    }
    return (<Img src={imageUrl(images[0].path)} alt={alt} />);
  };

  return (
    <Container>
      {
        renderImage()
      }
    </Container>
  );
};

export default connect((state) => ({ localityId: state.app.localityId }))(Image);
